import { useState } from 'react';
import { changePassword } from '../data/authActions';
import { useIsMobile } from '../hooks/useIsMobile';

export default function ChangePasswordModal({ onClose }) {
  const isMobile = useIsMobile();
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr('');
    if (next.length < 6) return setErr('New password must be at least 6 characters.');
    if (next !== confirm) return setErr('New passwords do not match.');
    setBusy(true);
    try {
      await changePassword({ currentPassword: cur, newPassword: next });
      setDone(true);
    } catch {
      setErr('Could not change password. Check your current password and try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal-scrim" onClick={onClose}>
      <div className={`modal${isMobile ? ' sheet-full' : ''}`} role="dialog" aria-label="Change password" onClick={(e) => e.stopPropagation()}>
        <header>Change password</header>
        {done ? (
          <div className="body">
            <p>Password updated.</p>
            <button className="btn btn-primary" onClick={onClose}>Done</button>
          </div>
        ) : (
          <form onSubmit={submit} className="body">
            {err && <div className="form-error" role="alert">{err}</div>}
            <input className="input" type="password" autoComplete="current-password" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} required />
            <input className="input" type="password" autoComplete="off" placeholder="New password" value={next} onChange={(e) => setNext(e.target.value)} required />
            <input className="input" type="password" autoComplete="off" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
            <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
              <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={busy}>{busy ? 'Saving…' : 'Update password'}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
